<div class="modal" [class.is-active]="open">
  <div class="modal-background" (click)="onDismiss($event)"></div>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title" [innerHTML]="title"></p>
      <button
        *ngIf="dismissible"
        class="delete"
        aria-label="close"
        (click)="onDismiss($event)"
      ></button>
    </header>
    <section class="modal-card-body">
      <ng-content></ng-content>
    </section>
    <footer
      class="modal-card-foot has-text-right"
      *ngIf="cancelButtonText || confirmButtonText"
    >
      <button
        class="button is-white is-rounded"
        *ngIf="cancelButtonText"
        (click)="onCancel($event)"
      >
        {{ cancelButtonText }}
      </button>
      <button
        class="button is-primary is-rounded"
        *ngIf="confirmButtonText"
        (click)="onConfirm($event)"
      >
        {{ confirmButtonText }}
      </button>
    </footer>
  </div>
</div>
